import React from 'react';

export function StatsChart() {
    <></>;
}
